import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { setAccessToken } from '../../../modules/auth/actions/creators'

import {
  setPrimaryInfo,
  displayProfileModal,
  setProfileModalPage,
} from '../../../modules/profile/actions/creators'

import {
  setRecoveryStep,
  setRecoveryRequestId,
} from '../../../modules/recovery/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import UpdateProfilePage from '../components/UpdateProfilePage/UpdateProfilePage'

import { doSubscribeToFirebaseMessaging } from '../../../controllers/Firebase'
import {
  doUpdateMobile,
  doVerifyUpdateMobile,
  doResendUpdateMobile,
} from '../../../controllers/AccountRecovery'
import {
  doUpdateProfile,
  doSubmitAvatar,
  doResendOTPUpdateProfile,
  doVerifyOTPUpdateProfile,
} from '../../../controllers/Profile'
import { storeAccessToken } from '../../../services/data/accessToken'

const saveAccessToken = accessToken => {
  storeAccessToken(accessToken)
  return {
    type: '',
    payload: {},
  }
}

const mapStateToProps = reduxState => {
  const { auth, profile, recovery } = reduxState

  const { accessToken, firebaseMessagingToken } = auth
  const { recoveryStep, recoveryRequestId } = recovery

  const {
    primaryInfo,
    showProfileModal,
    profileModalPage,
    emailVerificationStatus,
  } = profile

  return {
    accessToken,
    primaryInfo,
    showProfileModal,
    profileModalPage,
    emailVerificationStatus,
    recoveryStep,
    recoveryRequestId,
    firebaseMessagingToken,
    doSubscribeToFirebaseMessaging,
    saveAccessToken,
    //Account Recovery
    doUpdateMobile,
    doVerifyUpdateMobile,
    doResendUpdateMobile,
    // Update Profile
    doUpdateProfile,
    doSubmitAvatar,
    doResendOTPUpdateProfile,
    doVerifyOTPUpdateProfile,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setAccessToken,
      setPrimaryInfo,
      displayProfileModal,
      setProfileModalPage,
      setRecoveryStep,
      waitRenderServer,
      renderServer,
      setRecoveryRequestId,
    },
    dispatch,
  )

const ConnectedUpdateProfilePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateProfilePage)

export default ConnectedUpdateProfilePage
